module.exports = __webpack_public_path__ + "static/media/dataPharmLogo2.3b86ff93.png";